import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { Paragraph } from '@scentregroup/ui'
import { ShippingDeadlineResult } from '../../../../lib/get-shipping-deadlines'
import style from './index.module.scss'
import FulfilmentInfo from './fulfilment-info-picker'
import formatMoney from '@scentregroup/shared/helpers/format-money'

type TFulfillmentMemberBenefits = React.FC<
  React.PropsWithChildren<{
    memberBenefitsText: string
    memberBenefitsLink?: {
      href: string
      text: string
    }
  }>
>

export const FulfilmentPanelBenefits: TFulfillmentMemberBenefits = ({
  memberBenefitsText,
  memberBenefitsLink,
}) => {
  return (
    <div className={style.memberBenefits}>
      <Paragraph type="small" className={style.fulfilmentBenefits}>
        {memberBenefitsLink && (
          <>
            <Link to={memberBenefitsLink.href}>{memberBenefitsLink.text}</Link>{' '}
          </>
        )}
        {memberBenefitsText}
      </Paragraph>
    </div>
  )
}

interface IFulfilmentPanelProps {
  shippingCost: number
  shippingDeadline: ShippingDeadlineResult
}

const ItemFulfilmentPanel: React.FunctionComponent<
  React.PropsWithChildren<IFulfilmentPanelProps>
> = ({ shippingCost, shippingDeadline }) => {
  const [isRendered, setIsRendered] = useState(false)
  useEffect(() => setIsRendered(true), [])

  return isRendered ? (
    <div>
      <div className={style.fulfilmentShop}>
        {shippingDeadline && (
          <FulfilmentInfo
            iconType="info-concierge"
            title={shippingDeadline.title}
            titleHref={shippingDeadline.titleHref}
            memberBenefitsText={shippingDeadline.bodyCopy}
            dataTestId="fullfilment-cutoff-panel"
          />
        )}

        <FulfilmentInfo
          iconType="click-and-collect"
          title="Free Click &#38; Collect"
          dataTestId="click-and-collect-panel"
        />
        <FulfilmentInfo
          iconType="delivery"
          title={`Delivery ${formatMoney(shippingCost, {
            zeroText: 'is free',
          })}`}
          dataTestId="delivery-panel"
        />
        <FulfilmentInfo
          iconType="westfield-direct-returns"
          title="Free and easy returns"
          dataTestId="westfield-direct-returns"
        />
      </div>
    </div>
  ) : null
}

export default ItemFulfilmentPanel
